<template>
  <div class="c-aed-ownerCreate">
    <div class="o-grid o-grid--gutter-small">
      <div class="o-grid__group">
        <div class="o-grid__item o-grid__item--12">
          <h4
            class="c-aed-adminChange__text-label o-heading o-heading--bold o-heading--border o-heading--size-4 o-label o-label--block"
          >
            {{ translationsOwnerModal.orCreateNewOwner }}
          </h4>
        </div>
        <div class="o-grid__item o-grid__item--6">
          <label for="" class="o-label o-label--block">{{
            translationsCustom.firstName
          }}</label>
          <input
            type="text"
            :placeholder="translationsCustom.firstName"
            v-model="newOwner.firstName"
            class="c-aed-ownerCreate__input o-input o-input--modal"
          />
        </div>
        <div class="o-grid__item o-grid__item--6">
          <label for="" class="o-label o-label--block">{{
            translationsCustom.lastName
          }}</label>
          <input
            type="text"
            :placeholder="translationsCustom.lastName"
            v-model="newOwner.lastName"
            class="c-aed-ownerCreate__input o-input o-input--modal"
          />
        </div>
        <div class="o-grid__item o-grid__item--12">
          <label for="" class="o-label o-label--block">{{
            translationsCustom.email
          }}</label>
          <input
            type="email"
            pattern="/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/"
            :placeholder="translationsCustom.email"
            v-model="newOwner.email"
            :class="{
              'o-input--is-invalid': newOwner.email.length > 0 && !isValidEmail
            }"
            class="c-aed-ownerCreate__input o-input
          o-input--modal"
          />
        </div>
        <div class="o-grid__item o-grid__item--6">
          <label for="" class="o-label o-label--block">{{
            translationsCustom.mobile
          }}</label>
          <input
            type="text"
            :placeholder="translationsCustom.mobile"
            maxlength="8"
            @keydown="onlyNumbers"
            v-model="newOwner.mobile"
            class="c-aed-ownerCreate__input o-input o-input--modal"
          />
        </div>
        <div class="o-grid__item o-grid__item--6">
          <label for="" class="o-label o-label--block">{{
            translationsCustom.primary
          }}</label>
          <input
            type="text"
            :placeholder="translationsCustom.primary"
            maxlength="8"
            @keydown="onlyNumbers"
            v-model="newOwner.primaryPhone"
            class="c-aed-ownerCreate__input o-input o-input--modal"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      section: "profile"
    };
  },
  computed: {
    ...mapState("owners", ["owners", "newOwner", "selectedOwner"]),
    ...mapState("translations", {
      translationsOwnerModal: "ownerModal",
      translationsCustom: "custom"
    }),
    isValidEmail() {
      return /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(
        this.newOwner.email
      );
    },
    isOwnerValid() {
      return (
        this.newOwner.lastName.length > 0 &&
        this.newOwner.firstName.length > 0 &&
        this.isValidEmail
      );
    }
  },
  watch: {
    isValidEmail(newValue) {
      if (newValue) {
        this.$store.commit("owners/setSelectedOwner");
      }
    },
    selectedOwner(newValue) {
      if (newValue !== undefined) {
        this.$store.commit("owners/resetNewOwner");
      }
    },
    isOwnerValid(newValue, oldvalue) {
      if (newValue !== oldvalue) {
        this.$store.commit("owners/setNewUserValidity", newValue);
      }
    }
  }
};
</script>

<style lang="scss">
.c-aed-ownerCreate {
  &__input {
    width: 100%;
  }
  &__list {
    border-top: 1px solid $s-cp-neutral-600;
    border-bottom: 1px solid $s-cp-neutral-600;
    max-height: 235px;
    overflow: auto;
  }
  &__item {
    padding: 15px 0 20px;
    border-bottom: 1px solid $s-cp-neutral-600;
    &:last-child {
      border-color: transparent;
    }
  }

  &__item-name {
    color: $s-cp-sup-blue;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
  &__item-email {
    color: $s-cp-neutral-400;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
}
</style>
